export const MANPLUS_BUMPER_AD_SECTION_ID = "806473";
export const MANPLUS_PRE_ROLL_AD_SECTION_ID = "806494";

export const BUZZVIL_AOS_APP_ID = "291106423926220"; // prod: 458288649468170
export const BUZZVIL_IOS_APP_ID = "501061024551330"; // prod: 236486698223193
export const BUZZVIL_AOS_UNIT_ID = "387995290917201"; // prod: 562653933176263
export const BUZZVIL_IOS_UNIT_ID = "76927096602748"; // prod: 503674027586548

export const MANPLUS_BANNER_AD_SECTION_ID = {
  "320_50": "806501",
  "320_100": "806497",
  "300_250": "806504",
  "480_320": "806503",
  "640_960": "806502",
};

export const AD_RANGE_OPTION = {
  START: "start",
  FIRST_QUARTILE: "firstQuartile",
  MIDPOINT: "midpoint",
  THIRD_QUARTILE: "thirdQuartile",
  COMPLETE: "complete",
  SKIP: "skip",
  PROGRESS_BILLING: "progress_billing",
  PROGRESS_COMPLETE: "progress_complete",
};

export const getAdSize = url => {
  return url.split("ad_banner_gui_")[1].split(".png")[0];
};

export const GOOGLE_DATA_AD_CLIENT = "ca-pub-6073477345717326";

export const GOOGLE_AD_LIST = [
  {size: "320_100", dataAdSlot: "7035309883"},
  {size: "320_200", dataAdSlot: "4409146541"},
  {size: "320_500", dataAdSlot: "8723796079"},
  {size: "400_400", dataAdSlot: "2944005723"},
  {size: "800_120", dataAdSlot: "1243911244"},
];
